module.exports = __webpack_public_path__ + "img/strategy.8e0fe1f8.svg";